import { message } from "antd"
import { useTypedSelector } from "../../../hooks/useTypedSelector"
import { ITargetDataForTable } from "../types/sbTarget.types"
import { ITargetData } from "../types/sbTargetApi.types"
import { useMetrics } from "../../../hooks/useMetrics"
import {
  applyTargetMetrics,
  findCampaignAov,
  resolveCampaignTargetAcosWithMode,
} from "./helpers/targetMetrics.helper"

export const UseTargetsMetrics = (campaignName: string) => {
  const { calcBestCPC } = useMetrics()
  const { campaignData } = useTypedSelector((select) => select.sponsoredBrands)

  function calcTargetACOS(targets: ITargetDataForTable[]): ITargetDataForTable[] {
    return targets.map((target) => ({
      ...target,
      ...resolveCampaignTargetAcosWithMode(
        campaignName,
        campaignData.defaultTargetAcos,
        target.cvr,
        target.ladderFixedAcos
      ),
    }))
  }

  function applyMetrics(targets: ITargetDataForTable[]): ITargetDataForTable[] {
    const aov = findCampaignAov(campaignData.getAOVData?.aovs, campaignName)
    if (!aov) {
      message.error("AOV not found")
      return []
    }

    return applyTargetMetrics(
      targets,
      {
        defaultBid: campaignData.defaultBid,
        minTargetCPC: campaignData.minTargetCPC,
        maxTargetCPC: campaignData.maxTargetCPC,
        limitedCPCConditions: campaignData.limitedCPCValue?.conditions ?? null,
        aovValue: aov.value,
      },
      { calcBestCPC }
    )
  }

  function calcAllMetrics(targetData: ITargetData[]): ITargetDataForTable[] {
    return applyMetrics(calcTargetACOS(buildTargetsForTable(targetData)))
  }

  function buildTargetsForTable(targetData: ITargetData[]) {
    const targetForTable: ITargetDataForTable[] = targetData.map((target) => {
      return {
        ...target,
        targetCPC: 0,
        bestCPC: 0,
        finalBid: null,
      }
    })
    return targetForTable
  }

  function calcMetricsBeforeUpdatedAcos(targetData: ITargetDataForTable[]): ITargetDataForTable[] {
    return applyMetrics(targetData)
  }

  return {
    calcTargetACOS,
    calcAllMetrics,
    calcMetricsBeforeUpdatedAcos,
    buildTargetsForTable,
  }
}
